import { Component, OnInit } from '@angular/core';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { AlertService } from 'src/app/services/alert.service';
// declare var $: any
@Component({
  selector: 'app-change-user-status',
  templateUrl: './change-user-status.component.html',
  styleUrls: ['./change-user-status.component.css']
})
export class ChangeUserStatusComponent implements OnInit {
  is_edit: any;
  id: any;
  app_id: any;
  model: any = {};
  isLoading: boolean;
  isSavingData:boolean=false
  constructor(private checkPermissionService: CheckPermissionService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private alertService: AlertService,
    private router: Router) {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.app_id = this.activatedRoute.snapshot.params['app_id'];
  }

  ngOnInit() {
    this.getuserbyId();
    this.is_edit = this.checkPermissionService.getAction('edit');
    localStorage.setItem('option', 'global_access_control');
  }
  
  getuserbyId() {
    this.isLoading=true
    this.authService.getuserbyId(this.id).subscribe((res) => {
      this.model = res;
      if (this.model.status + "" == "ACTIVATED") {
        this.model.status = true;
      }
      else {
        this.model.status = false;
      }
      // this.isLoading=true
    }, error => {this.isLoading=false},
      () => {})
  }
  updateUser() {
    if (this.model.status == true) {
      this.model.status = "ACTIVATED";
    }
    else {
      this.model.status = "DE-ACTIVATED";
    }
    this.isSavingData=true
    this.authService.updateUser(this.model).subscribe((res) => {
      this.model = res
    }, error => {this.isSavingData=false},
     () => {
      this.isSavingData=false
      this.alertService.updateAlert("User Updated Successfully");
      this.router.navigate(['/user-listing/' + this.app_id]);
    })
  }
}
